module.exports = __webpack_public_path__ + "static/media/add-participant.912d2afb.svg";